import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';
import { RegistroService } from 'src/app/registro.service';

@Injectable({
    providedIn: 'root',
})
export class ComercializadorService {
    private readonly _apiUrl: string = environment.apiSiriUrl;
    public constructor(
        private http: HttpClient,
        protected readonly keycloakService: KeycloakService,
        private registroService: RegistroService
    ) {}

    /** Preguntas comercializador */
    public getPreguntasComercializador(
        tipo: string,
        parentId?: number
    ): Observable<any> {
        let url = `${this._apiUrl}comercializador/${tipo}`;
        if (parentId) url += `?parentId=${parentId}`;
        return this.http.get<any>(url);
    }

    /** Traer las preguntas por id */
    public getPreguntaById(table: string, id: number): Observable<unknown> {
        const url = `${this._apiUrl}comercializador/${table}/${id}`;
        return this.http.get<unknown>(url);
    }

    /**
     *  Busca un comercializador por el id del agente vigilado
     * @param agenteVigiladoId
     * @returns
     */
    public findByAgenteVigiladoId(agenteVigiladoId: number): Observable<any> {
        return this.http.get(
            `${this._apiUrl}comercializador/agente-vigilado/${agenteVigiladoId}`
        );
    }

    /**
     * Obtiene todos los comercializadores con paginación
     */
    public getPagedComercializadores(
        page: string,
        limit: string,
        filtros?: {
            nit?: string;
            razonSocial?: string;
            fechaAsignacion?: string;
            tamanoComercializador?: string;
        }
    ): Observable<any> {
        let params = new HttpParams().set('page', page).set('limit', limit);

        //  Enviar los filtros como parámetros planos
        if (filtros) {
            for (const key of Object.keys(filtros)) {
                const value = filtros[key];
                if (value !== undefined && value !== null && value !== '') {
                    params = params.set(key, value);
                }
            }
        }

        return this.http.get<any>(`${this._apiUrl}comercializador`, { params });
    }

    /** Guarda o asigna la clasificación/tamaño del comercializador */
    public asignarTamano(
        asignaciones: Array<{ id: string; tamanoComercializador: string }>
    ): Observable<any> {
        const url = `${this._apiUrl}comercializador/asignar-tamano`;
        return this.http.post(url, asignaciones);
    }

    /** Obtiene la caracterización de un comercializador por su ID */
    public getComercializador(id: number): Observable<unknown> {
        return this.http.get(`${this._apiUrl}comercializador/id/${id}`);
    }
}
